import axios from 'axios';

const api = axios.create({
  //baseURL: 'https://api.deheus.yorbit.com.br:59044',
	baseURL: 'https://api.deheus.yorbit.com.br', //base testes
});

export default api;
